import React from 'react'
import { Label,Icon } from 'semantic-ui-react'

class Tags extends React.Component {

    render() {
        return <div>
            {
                this.props.filtros.map(item => (
                    <Label as='a' key={item.value} size='large' basic >
                        {this.props.eventos.filter(x => x[item.key] === item.value).length}
                        <Label.Detail onClick={() => this.onSelectTag(item.key, item.value)}> {item.value}</Label.Detail>
                        {item.selected && <Icon name='delete' onClick={() => this.onSelectTag('', '')} />}
                    </Label>
                ))
            }
        </div>
    }
    onSelectTag = (key, value) => {
        if (this.props.onSelectTag)
            this.props.onSelectTag(key, value)
    }
}

export default Tags


// WEBPACK FOOTER //
// ./src/components/Eventos/Pesquisa/Tags.js